import { render, staticRenderFns } from "./VNewMissingInvoiceData.vue?vue&type=template&id=73ca4748&"
import script from "./VNewMissingInvoiceData.vue?vue&type=script&lang=js&"
export * from "./VNewMissingInvoiceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports